import { atom } from 'jotai'

export const showAddNewUsageEventDrawerAtom = atom(false)
